import React from 'react';
import { RadarChart, Radar, PolarGrid, PolarAngleAxis, ResponsiveContainer } from 'recharts';

const card = {
  background: 'rgba(30,45,79,0.5)',
  borderRadius: '16px',
  border: '1px solid rgba(0,194,168,0.1)',
  padding: '24px',
};

function BarRow({ label, rate, color }) {
  return (
    <div style={{ marginBottom:'16px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'6px' }}>
        <span style={{ fontFamily:'Space Grotesk', fontSize:'13px', color:'#7B9CC8' }}>{label}</span>
        <span style={{ fontFamily:'JetBrains Mono', fontSize:'13px', color, fontWeight:600 }}>{rate}%</span>
      </div>
      <div style={{ height:'8px', background:'#1E2D4F', borderRadius:'4px', overflow:'hidden' }}>
        <div style={{
          height:'100%', width:`${rate}%`,
          background: `linear-gradient(90deg, ${color}, ${color}99)`,
          borderRadius:'4px',
          transition:'width 1s cubic-bezier(0.4,0,0.2,1)',
          boxShadow: `0 0 8px ${color}60`,
        }} />
      </div>
    </div>
  );
}

export default function AlignmentChart({ dkimRate, spfRate, passRate }) {
  const failRate = 100 - passRate;

  return (
    <div style={card}>
      <div style={{ marginBottom:'24px' }}>
        <div style={{ fontFamily:'Space Grotesk', fontWeight:600, fontSize:'16px', color:'#F0F4FF' }}>Authentication Alignment</div>
        <div style={{ fontFamily:'Inter', fontSize:'12px', color:'#5B7BA8', marginTop:'4px' }}>SPF and DKIM pass rates</div>
      </div>

      <BarRow label="DKIM Alignment" rate={dkimRate} color="#00C2A8" />
      <BarRow label="SPF Alignment" rate={spfRate} color="#0088CC" />
      <BarRow label="Overall DMARC Pass" rate={passRate} color="#8B5CF6" />
      <BarRow label="DMARC Fail" rate={failRate} color="#E8415A" />

      <div style={{ marginTop:'20px', padding:'12px', background:'rgba(0,194,168,0.06)', borderRadius:'8px', border:'1px solid rgba(0,194,168,0.1)' }}>
        <div style={{ fontFamily:'Inter', fontSize:'12px', color:'#5B7BA8', lineHeight:1.6 }}>
          DMARC passes if <strong style={{ color:'#00C2A8' }}>either</strong> DKIM or SPF is aligned with the From domain.
          Both failing = DMARC fail.
        </div>
      </div>
    </div>
  );
}
